export default __webpack_public_path__ + "static/media/logo web.5d750404.svg";